// Owner-approved Loki appearance release: preserve the installed gallery app and its interactions.
(() => {
 if(window.lokiPreviewPhotoCorrection)return;
 window.lokiPreviewPhotoCorrection=true;
 function correct(){
  const config=document.querySelector('[data-loki-preview-photo-map]');if(!config)return;
  const map=JSON.parse(config.textContent);
  for(const img of document.images){
   const original=['src','data-src','data-zoom'].map(a=>(img.getAttribute(a)||'').split('/').pop().split('?')[0]).find(n=>map[n]);
   const replacement=map[original];if(!replacement)continue;
   img.removeAttribute('srcset');img.removeAttribute('data-srcset');
   img.src=replacement;if(img.hasAttribute('data-src'))img.dataset.src=replacement;if(img.hasAttribute('data-zoom'))img.dataset.zoom=replacement;
   img.alt='Original satin gold Loki hinge photograph; exact small/medium size assignment remains provisional';
   img.dataset.lokiCorrectedPhoto='';
  }
 }
 let queued=false;const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;correct()});};
 new MutationObserver(schedule).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['src','srcset']});
 correct();
})();
